import React, { useEffect, useRef } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Navbar from "../pages/Navbar";
import Footer from "../pages/Footer";
import { siteInfo } from "../data/siteInfo";
import { privatePartyPackages, formatPackagePrice } from "../data/packages";
import Icon from "./Icon";

const startingPartyPrice = formatPackagePrice(
  Math.min(...privatePartyPackages.map((pkg) => pkg.price)),
);

const descriptions = {
  "/": [
    "Kiddie Kingdom | Indoor Play & Birthday Parties in Northridge",
    "Explore Kiddie Kingdom’s indoor playground in Northridge. Find open-play pricing, compare private birthday parties, see the space, and plan your visit.",
  ],
  "/packagesdetail": [
    "Birthday Party Packages | Kiddie Kingdom, Northridge",
    `Compare birthday packages from ${startingPartyPrice}, weekday parties, rentals, and add-ons. No service fees. 10.25% tax applies. See inclusions and payment policies.`,
  ],
  "/book": [
    "Plan Your Party | Kiddie Kingdom",
    "Send a party inquiry to Kiddie Kingdom. Choose a package, review guest pricing and a tax estimate, and tell us your preferred date. Our team will confirm availability.",
  ],
  "/privacy-policy": [
    "Privacy Policy | Kiddie Kingdom",
    "Read how Kiddie Kingdom collects, uses, and protects information submitted through our website.",
  ],
};

export default function SiteLayout() {
  const { pathname, hash, key } = useLocation();
  const firstVisit = useRef(true);
  const previousLocation = useRef({ pathname, hash });
  const mainRef = useRef(null);
  useEffect(() => {
    const previous = previousLocation.current;
    previousLocation.current = { pathname, hash };
    if (
      !firstVisit.current &&
      !hash &&
      previous.pathname === pathname &&
      previous.hash === hash
    )
      return;
    const [title, description] = descriptions[pathname] || [
      "Page Not Found | Kiddie Kingdom",
      "Find open play, birthday packages, and contact information for Kiddie Kingdom.",
    ];
    document.title = title;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute("content", description);
    document
      .querySelector('meta[property="og:title"]')
      ?.setAttribute("content", title);
    document
      .querySelector('meta[property="og:description"]')
      ?.setAttribute("content", description);
    if (hash) {
      document
        .getElementById(hash.slice(1))
        ?.scrollIntoView({ block: "start" });
    } else {
      window.scrollTo(0, 0);
      if (!firstVisit.current) mainRef.current?.focus({ preventScroll: true });
    }
    firstVisit.current = false;
  }, [pathname, hash, key]);

  const showMobileBooking = pathname === "/" || pathname === "/packagesdetail";
  return (
    <div
      className={`site-shell${showMobileBooking ? " has-mobile-booking" : ""}`}
    >
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <Navbar />
      <main id="main-content" ref={mainRef} tabIndex="-1">
        <Outlet />
      </main>
      <Footer />
      {showMobileBooking && (
        <aside className="mobile-booking-bar" aria-label="Quick booking">
          <a href={siteInfo.phoneHref} className="button button-secondary">
            <Icon name="phone" /> Call us
          </a>
          <Link to="/book" className="button button-primary">
            Book a Party <Icon />
          </Link>
        </aside>
      )}
    </div>
  );
}
